/**
 * Settings Component
 */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import AppearanceSelector from './AppearanceSelector';

function Settings({ companyId, companyTheme = null }) {
  const { t } = useTranslation();
  const companyDefault = companyTheme?.company || null;
  const [seedingSynthetic, setSeedingSynthetic] = useState(false);
  const [seedError, setSeedError] = useState('');
  const [seedResult, setSeedResult] = useState(null);

  const handleSeedSyntheticData = async () => {
    if (!companyId) return;
    const confirmed = window.confirm(
      'Se poblaran datos sinteticos de demo en la empresa seleccionada. La operacion es idempotente y reutiliza el mismo pack demo. ¿Continuar?'
    );
    if (!confirmed) return;

    setSeedingSynthetic(true);
    setSeedError('');
    try {
      const result = await api.seedSyntheticCompanyData(companyId);
      setSeedResult(result);
    } catch (error) {
      setSeedError(error.message || 'No se pudieron crear los datos sinteticos');
    } finally {
      setSeedingSynthetic(false);
    }
  };

  return (
    <div className="settings-container" style={{ maxWidth: '720px', margin: '24px auto' }}>
      <div className="card">
        <div className="card-header">
          <h5 className="card-title mb-0">{t('nav.settings')}</h5>
        </div>
        <div className="card-body">
          <div className="mb-4">
            <label className="form-label">{t('appearance.title', 'Apariencia')}</label>
            <AppearanceSelector
              companyId={companyId}
              companyDefault={companyDefault}
              serverTheme={companyTheme}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Application Information</label>
            <div className="alert alert-info">
              <strong>CMDB</strong> - Configuration Management Database<br />
              Version: 0.1.0<br />
              IdP Integration: Connected<br />
              <small>© 2025 ADDER Ecosystem</small>
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">Datos sinteticos de demo</label>
            <div className="card border-0 bg-light">
              <div className="card-body">
                <div className="small text-muted mb-3">
                  Genera un entorno de ejemplo para la empresa seleccionada con racks, PDUs,
                  switches, patch panels, servidores con hardware y discos, conexiones de red,
                  alimentacion y estaciones de trabajo.
                </div>

                {seedResult && (
                  <div className="alert alert-success py-2">
                    <strong>{seedResult.message}</strong><br />
                    <small>
                      Racks: {seedResult.summary?.racks || 0} · Servidores: {seedResult.summary?.servers || 0} ·
                      Switches: {seedResult.summary?.switches || 0} · PDUs: {seedResult.summary?.pdus || 0} ·
                      Workstations: {seedResult.summary?.workstations || 0} · Conexiones: {seedResult.summary?.port_connections || 0}
                    </small>
                  </div>
                )}

                {seedError && (
                  <div className="alert alert-danger py-2">
                    <strong>Error:</strong> {seedError}
                  </div>
                )}

                <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                  <div className="small text-muted">
                    {companyId
                      ? `Empresa activa: ${companyId}`
                      : 'Selecciona una empresa para habilitar la carga sintetica.'}
                  </div>
                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={handleSeedSyntheticData}
                    disabled={!companyId || seedingSynthetic}
                  >
                    {seedingSynthetic ? 'Poblando...' : 'Poblar datos sinteticos'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;

